import { TransformationInterface } from '@simOn/common/matterport';

export function IsCorrectTransformation(transformation: TransformationInterface) {
  return !(transformation.position === null) && !(transformation.normalVector === null);
}
